import React from "react";
import axios from "axios";
import useAuth from '../hooks/useAuth';
import {Link, useLocation, useNavigate, Navigate} from 'react-router-dom';
import useDocumentTitle from "../hooks/useDocumentTitle";
import {PhoneIcon} from "../assets/icons";
import AuthApi from "../api/AuthApi";
import ModalAjax from "../components/main/ModalAjax";
import { notification } from "antd";

const LoginPage = () => {

    useDocumentTitle('Авторизация');
    const [apiNotification, contextHolder] = notification.useNotification();
    const { setAuth, setRoles, setUser } = useAuth();
    const navigate = useNavigate();
    const loginRef = React.useRef(null);
    const passwordRef = React.useRef(null);
    const [ isError, setIsError ] = React.useState(false);
    const [ isLogin, setIsLogin ] = React.useState(false);
    const [ isErrorLogin, setErrorLogin ] = React.useState(false);
    const [valueLogin, setValueLogin] = React.useState('+7 ');
    const [ isOpenUserInfo, setIsOpenUserInfo ] = React.useState(false);

    // forgot
    const [userId, setUserId] = React.useState(0);
    const [ isSendCode, setIsSendCode ] = React.useState(false);
    const [valueVerifyCode, setValueVerifyCode] = React.useState('');
    const [ isErrorVerifyCode, setIsErrorVerifyCode ] = React.useState(false);

    const authorize = () => {

        const login = loginRef.current?.value;
        const password = passwordRef.current?.value;
        setErrorLogin(false);

        if (login && password) {

            setIsError(false);

            AuthApi.login(login, password).then((data) => {
                if (data.status === 'success' && data.content.token) {
                    localStorage.setItem('token', data.content.token);
                    setIsLogin(true);
                    setAuth(true);
                    // set Roles
                    let roles = ['ROLE_USER'];
                    if (data.content.roles) {
                        roles = data.content.roles;
                        localStorage.setItem('roles', JSON.stringify(roles));
                        setRoles(roles);
                        let currentUser = {
                            id: data.content.id,
                            login: data.content.login,
                            name: data.content.name,
                            avatar: data.content.avatar
                        }
                        localStorage.setItem('user', JSON.stringify(currentUser));
                        setUser(currentUser);
                    }

                } else {
                    setIsError(true);
                    apiNotification['error']({
                        message: 'Ошибка авторизации',
                        description:
                            'Логин или пароль введены неверно',
                    });
                }
            });

        } else {
            setIsError(true);
            apiNotification['error']({
                message: 'Ошибка авторизации',
                description:
                    'Логин или пароль введены неверно',
            });
        }


    }

    const handleKeypress = e => {
        if (e.keyCode === 13) {
            authorize();
        }
    };

    const handleChange = (event) => {

        let formatted = '';

        let numbersOnly = event.target?.value.replace(/\D/g, '');

        if (numbersOnly.length > 0) {
            formatted += '+7 ';
        }
        if (numbersOnly.length > 1) {
            formatted += '(' + numbersOnly.substring(1, 4);
        }
        if (numbersOnly.length > 4) {
            formatted += ') ' + numbersOnly.substring(4, 7);
        }
        if (numbersOnly.length > 7) {
            formatted += '-' + numbersOnly.substring(7, 9);
        }
        if (numbersOnly.length > 9) {
            formatted += '-' + numbersOnly.substring(9, 11);
        }


        /*if (result.length > 11) {
            result = result.substring(0, 11);
        }*/

        setValueLogin(formatted);
    }

    const handleChangeVerifyCode = (event) => {
        let result = event.target?.value;
        setValueVerifyCode(result);
    }

    const handleForgotPassword = () => {
        //setIsSendCode(true);
        let isErrorCurrent = false;

        let numbersOnly = valueLogin.replace(/\D/g, '');

        if (numbersOnly === '' || numbersOnly.length < 11) {
            isErrorCurrent = true;
        }
        setErrorLogin(false);
        if (!isErrorCurrent) {
            AuthApi.sendCode(valueLogin).then((data) => {
                if (data.status === 'success') {
                    setIsSendCode(true);
                    setUserId(data.content.id);
                } else {
                    setErrorLogin(true);
                    apiNotification['error']({
                        message: 'Ошибка',
                        description:
                            'Пользователь не найден или заблокирован',
                    });
                }
            });
        } else {
            setErrorLogin(true);
            apiNotification['error']({
                message: 'Ошибка',
                description:
                    'Для восстановления введите номер телефона или телефон введен неверно',
            });
        }
    }


    const verify = () => {
        if (valueVerifyCode === '') {
            setIsErrorVerifyCode(true);
        } else {
            AuthApi.verify(userId, valueVerifyCode).then((data) => {
                if (data.status === 'success' && data.content.token) {
                    localStorage.setItem('token', data.content.token);
                    setAuth(true);
                    let roles = ['ROLE_USER'];
                    if (data.content.roles) {
                        localStorage.setItem('roles', JSON.stringify(data.content.roles));
                        setRoles(data.content.roles);
                        let currentUser = {
                            id: data.content.id,
                            login: data.content.login,
                            name: data.content.name,
                            avatar: data.content.avatar
                        }
                        localStorage.setItem('user', JSON.stringify(currentUser));
                        setUser(currentUser);
                    }
                    navigate('/cabinet/profile', { replace: true });
                } else {
                    setIsErrorVerifyCode(true);
                    apiNotification['error']({
                        message: 'Ошибка',
                        description:
                            'Код указан неверно',
                    });
                }
            });
        }
    }

    return (
        <div className="w-full max-w-[26rem] p-4 sm:px-5">
            {contextHolder}
            <div className="text-center">
                <img
                    className="mx-auto h-16 w-16"
                    src="/icon.png"
                    alt="logo"
                />
                <div className="mt-4">
                    <h2 className="text-2xl font-semibold text-slate-600 dark:text-navy-100">
                        Авторизация
                    </h2>
                    <p className="text-slate-400 dark:text-navy-300">
                        Пожалуйста, авторизуйтесь для работы в системе
                    </p>
                </div>
            </div>
            {/* isError ?
                <div className="alert flex rounded-lg bg-error/10 px-4 py-4 text-error dark:bg-error/15 sm:px-5 mt-2">
                    Логин и пароль введены неверно
                </div> : '' */}
            <div className="card mt-5 rounded-lg p-5 lg:p-7">
                {
                    !isSendCode ? <>
                    <label className="block">
                    <span>Номер телефона:</span>
                    <span className="relative mt-1.5 flex">
                <input ref={loginRef}
                    className={`form-input peer w-full rounded-lg border bg-transparent ${isError || isErrorLogin ? 'border-error bg-error' : 'border-slate-300'} px-3 py-2 pl-9 placeholder:text-slate-400/70 hover:border-slate-400 focus:border-primary dark:border-navy-450 dark:hover:border-navy-400 dark:focus:border-accent`}
                    placeholder=""
                    type="text"
                       onKeyUp={handleKeypress}
                       onChange={handleChange}
                       value={valueLogin}
                />
                <span className="pointer-events-none absolute flex h-full w-10 items-center justify-center text-slate-400 peer-focus:text-primary dark:text-navy-300 dark:peer-focus:text-accent">
                    <PhoneIcon />
                </span>
              </span>
                </label>
                    <label className="mt-4 block">
                    <span>Пароль:</span>
                    <span className="relative mt-1.5 flex">
                <input ref={passwordRef}
                    className={`form-input peer w-full rounded-lg border bg-transparent ${isError ? 'border-error bg-error' : 'border-slate-300'} px-3 py-2 pl-9 placeholder:text-slate-400/70 hover:border-slate-400 focus:border-primary dark:border-navy-450 dark:hover:border-navy-400 dark:focus:border-accent`}
                    placeholder="Введите пароль"
                    type="password" onKeyUp={handleKeypress}
                />
                <span
                    className="pointer-events-none absolute flex h-full w-10 items-center justify-center text-slate-400 peer-focus:text-primary dark:text-navy-300 dark:peer-focus:text-accent"
                >
                  <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="h-5 w-5 transition-colors duration-200"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                  >
                    <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="1.5"
                        d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z"
                    />
                  </svg>
                </span>
              </span>
                </label>
                    <div className="mt-4 flex items-center justify-between space-x-2">
                    <button onClick={handleForgotPassword}
                        className="text-xs text-slate-400 transition-colors line-clamp-1 hover:text-slate-800 focus:text-slate-800 dark:text-navy-300 dark:hover:text-navy-100 dark:focus:text-navy-100"
                    >Забыли пароль?</button>
                </div>
                            <button onClick={authorize} className="btn mt-5 w-full bg-primary font-medium text-white hover:bg-primary-focus focus:bg-primary-focus active:bg-primary-focus/90 dark:bg-accent dark:hover:bg-accent-focus dark:focus:bg-accent-focus dark:active:bg-accent/90">
                                Войти
                            </button>
                    </>
                        :<>
                        <label className="mt-4 block">
                            <span>Код подтверждения:</span>
                            <span className="relative mt-1.5 flex">
                <input
                       className={`form-input peer w-full rounded-lg border border-${isErrorVerifyCode ? 'error' : 'slate-300'} bg-transparent px-3 py-2 pl-9 placeholder:text-slate-400/70 hover:border-slate-400 focus:border-primary dark:border-navy-450 dark:hover:border-navy-400 dark:focus:border-accent`}
                       placeholder="Введите код из SMS или E-mail"
                       type="text"
                       onChange={handleChangeVerifyCode}
                       value={valueVerifyCode}
                />
                <span
                    className="pointer-events-none absolute flex h-full w-10 items-center justify-center text-slate-400 peer-focus:text-primary dark:text-navy-300 dark:peer-focus:text-accent"
                >
                  <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="h-5 w-5 transition-colors duration-200"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                  >
                    <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="1.5"
                        d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z"
                    />
                  </svg>
                </span>
              </span>
                        </label>
                            <button onClick={verify} className="btn mt-5 w-full bg-primary font-medium text-white hover:bg-primary-focus focus:bg-primary-focus active:bg-primary-focus/90 dark:bg-accent dark:hover:bg-accent-focus dark:focus:bg-accent-focus dark:active:bg-accent/90">
                                Подтвердить
                            </button>
                        </>
                }
                <div className="mt-4 text-center text-xs+">
                    <p className="line-clamp-1">
                        <span>Нет аккаунта?</span>&nbsp;

                        <Link
                            className="text-primary transition-colors hover:text-primary-focus dark:text-accent-light dark:hover:text-accent"
                            to="/auth/register"
                        >Создать аккаунт</Link
                        >
                    </p>
                </div>
            </div>
            <div className="mt-8 flex justify-center text-xs text-slate-400 dark:text-navy-300">
                <a href="#" onClick={() => setIsOpenUserInfo(true)}>Пользовательское соглашение</a>
            </div>
            <ModalAjax source={"term_of_use"} isOpen={isOpenUserInfo} onClose={() => setIsOpenUserInfo(false)}/>
        </div>
    );

}

export default LoginPage;
